import { render } from "./BannerAdmin.vue?vue&type=template&id=50df9692&scoped=true"
import script from "./BannerAdmin.vue?vue&type=script&lang=js"
export * from "./BannerAdmin.vue?vue&type=script&lang=js"

import "./BannerAdmin.vue?vue&type=style&index=0&id=50df9692&scoped=true&lang=less"

import exportComponent from "D:\\Tsubakimoto\\Tsubakimoto_mvc\\Tsubakimoto\\tsubakimoto_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50df9692"]])

export default __exports__